export default __webpack_public_path__ + "static/media/download-icon.2ef47e8e.svg";